// Shared loading / error / empty presentational states for data-backed
// sections. Keeps Firestore-fetching pages tidy and consistent.
import { AlertCircle, RefreshCw } from "lucide-react";

/** Skeleton placeholder cards shown while data loads. */
export function LoadingGrid({ count = 3, className = "grid grid-cols-1 md:grid-cols-2 gap-8", testId = "loading-state" }) {
  return (
    <div className={className} data-testid={testId}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="border border-bronze/15 bg-cream overflow-hidden animate-pulse">
          <div className="aspect-[4/3] bg-bronze/10" />
          <div className="p-7 space-y-3">
            <div className="h-3 w-24 bg-bronze/10" />
            <div className="h-6 w-3/4 bg-bronze/15" />
            <div className="h-3 w-full bg-bronze/10" />
            <div className="h-3 w-5/6 bg-bronze/10" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Error state with a retry affordance. */
export function ErrorState({ onRetry, message, testId = "error-state" }) {
  return (
    <div className="py-20 text-center text-olive" data-testid={testId}>
      <AlertCircle className="mx-auto text-bronze" size={32} />
      <p className="font-serif text-2xl mt-4">We couldn't load this just now.</p>
      <p className="text-sm mt-2 text-ink_soft/70">
        {message || "Please check your connection and try again."}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="error-retry"
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 text-[0.7rem] tracking-[0.22em] uppercase border border-bronze/40 text-bronze hover:bg-bronze hover:text-cream transition-colors"
        >
          <RefreshCw size={14} /> Retry
        </button>
      )}
    </div>
  );
}

/** Empty state when a successful load returns no items. */
export function EmptyState({ title = "Nothing here yet.", sub, testId = "empty-state" }) {
  return (
    <div className="py-20 text-center text-olive" data-testid={testId}>
      <p className="font-serif text-2xl">{title}</p>
      {sub && <p className="text-sm mt-2 text-ink_soft/70">{sub}</p>}
    </div>
  );
}
